import { render, staticRenderFns } from "./printLogo.vue?vue&type=template&id=b642c632&scoped=true&"
import script from "./printLogo.vue?vue&type=script&lang=js&"
export * from "./printLogo.vue?vue&type=script&lang=js&"
import style0 from "./printLogo.vue?vue&type=style&index=0&id=b642c632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b642c632",
  null
  
)

export default component.exports